<template>
  <div id="app">
    <a-nav />
    <router-view/>
    <a-foot />
  </div>
</template>

<script>
import AFoot from '@/components/Common/foot'
import ANav from '@/components/Common/nav'
export default {
  name: 'App',
  components: { ANav, AFoot }
}
</script>

<style lang="scss" scoped>
#common {
  width: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue